import type { LegendActionTemplate } from '../../core/components/legend/categorical/hooks/useLegendSeriesActions.js';
import type { LegendItem } from '../../core/components/legend/categorical/types/legend.js';

export function getLegendInteractionProps(
  isPinned: boolean,
  hasNameAccessor: boolean,
  legendActions: LegendActionTemplate,
  onHover: (hoveredSeries?: LegendItem[]) => void,
  onClick: (visibleSlices: LegendItem[]) => void,
) {
  if (isPinned) {
    return { interactionsDisabled: true };
  }

  if (hasNameAccessor) {
    return {
      onHover: onHover,
      interactionsDisabled: true,
    };
  }

  return {
    onSeriesAction: legendActions,
    onHover: onHover,
    onClick: onClick,
    interactionsDisabled: false,
  };
}
